import { clockInZone, hoursLabel, line, t } from '@bms2/shared';
import type { Told } from './myJobsApi';
import styles from './MyJobs.module.css';

/** 🔒 The screen says what the press moved: the clock it ended at the same minute first, then what started (piece 29). */
export function toldNotice(told: Told, zone: string) {
  if (told.kind === 'submitted') return <p className={styles.told} role="status" data-my-jobs-told="submitted">{line(t('myJobs.submitted'), String(told.answer.submitted), t('myJobs.submittedEntries'), '·', hoursLabel(told.answer.hours))}</p>;
  if (told.kind === 'travel') return <p className={styles.told} role="status" data-my-jobs-told="travel">{line(t('myJobs.travelRecorded'), hoursLabel(told.answer.hours))}</p>;
  if (told.kind === 'tap') {
    const { tap, stamped, clockEnded } = told.answer;
    const said = tap === 'OnMyWay' ? t('myJobs.toldOnMyWay') : tap === 'Arrived' ? t('myJobs.toldArrived') : t('myJobs.toldLeaving');
    return (
      <p className={styles.told} role="status" data-my-jobs-told={`tap-${tap}`}>
        {line(said, tap !== 'Leaving' && !stamped ? t('myJobs.toldAgain') : null, clockEnded ? line(t('myJobs.clockStopped'), hoursLabel(clockEnded.hours)) : null, told.answer.checkedIn ? t('myJobs.checkedIn') : null, told.answer.checkedOut ? t('myJobs.checkedOut') : null)}
      </p>
    );
  }
  if (told.kind === 'out') {
    return (
      <p className={styles.told} role="status" data-my-jobs-told="out">
        {line(t('myJobs.stopped'), hoursLabel(told.answer.hours), told.answer.checkedOut ? t('myJobs.checkedOut') : null)}
      </p>
    );
  }
  const { ended, startedAt, visitStarted, jobStarted, checkedIn } = told.answer;
  return (
    <div className={styles.told} role="status" data-my-jobs-told="in">
      {ended ? <p className={styles.toldLine} data-my-jobs-ended={ended.entryId}>{line(t('myJobs.ended'), ended.workOrderNumber, ended.lineLabel ? `· ${ended.lineLabel}` : null, '·', hoursLabel(ended.hours), t('myJobs.endedHours'))}</p> : null}
      <p className={styles.toldLine}>{line(t('myJobs.started'), clockInZone(startedAt, zone), visitStarted ? t('myJobs.visitStarted') : null, jobStarted ? t('myJobs.jobStarted') : null, checkedIn ? t('myJobs.checkedIn') : null)}</p>
    </div>
  );
}
